<h1 id="small-title">{{selectedBlogEntry?.contentName}}</h1>
<div class="row">
    <div class="col">
        <p>Date: {{date | date}}</p>
    </div>
    <div class="col" style="text-align:right">
        <share-buttons [include]="['facebook', 'twitter']"></share-buttons>
    </div>
</div>
<hr/>
<div [innerHTML]="selectedBlogEntry.articleData"></div>
<div>
    <share-buttons [include]="['facebook', 'twitter']"></share-buttons>
</div>
<hr/>
